var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import Link, { RouterLink } from "@irati/ui/src/Link";
import { TextButton } from "@irati/ui/src/Button";
import { pressedStateNoBorder } from "@irati/ui/src/global/elevation";
var styling = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 10px;\n  border-radius: 2px;\n  position: relative;\n  white-space: nowrap;\n  font-weight: 400;\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  letter-spacing: 0.4px;\n\n  &:hover,\n  &:active,\n  &:focus {\n    outline: 0;\n  }\n  &:hover {\n    background-color: ", ";\n    text-decoration: none;\n  }\n  &:hover,\n  &:active {\n    background-color: ", ";\n  }\n  &:active {\n    ", "\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 10px;\n  border-radius: 2px;\n  position: relative;\n  white-space: nowrap;\n  font-weight: 400;\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  letter-spacing: 0.4px;\n\n  &:hover,\n  &:active,\n  &:focus {\n    outline: 0;\n  }\n  &:hover {\n    background-color: ", ";\n    text-decoration: none;\n  }\n  &:hover,\n  &:active {\n    background-color: ", ";\n  }\n  &:active {\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.mediumDark;
}, function (_a) {
    var height = _a.height;
    return height && "height: " + height + "px;";
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize && "font-size: " + fontSize + "px;";
}, function (_a) {
    var fontFamily = _a.fontFamily;
    return fontFamily && "font-family: " + fontFamily + ";";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.lightest;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.lightest;
}, pressedStateNoBorder);
export default styled(RouterLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styling);
export var StyledHeaderButton = styled(TextButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styling);
export var StyledHeaderAnchor = styled(Link)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styling);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
